import $ from 'jquery';
import LP from '../0-lp';
import UI from '../0-ui';

//=============== //
//SCALE QUESTION //
//=============== //
LP.scaleQuestion = {
    dispatching: false,

    onLoad: function () {
        var tabname = LP.Dialog.getTabName();
        switch (tabname) {
            case 'advanced'    :
                LP.scaleQuestion.advTab.initEvents();
                break;
            case 'codes'        :
                LP.questionTab.codes.initEvents();
                break;
        }
    },

    initNonAjaxTabs: function () {
        LP.scaleQuestion.scalesTab.initEvents();
    },

    scalesTab: {
        initEvents: function (root) {
            if (!root) root = $('#scaleFields');
            $('a[action="addScale"]', root).click(function () {
                LP.dlgQuestion.addOptionHere($('#newGroup'), this.parentNode, LP.scaleQuestion.scalesTab.initEvents);
            });
            $('a[action="editLeftText"]', root).click(function () {
                LP.dlgQuestion.editInput($('input[name="question[leftText][]"]', this.parentNode), this);
            });
            $('a[action="editRightText"]', root).click(function () {
                LP.dlgQuestion.editInput($('input[name="question[rightText][]"]', this.parentNode), this);
            });

            LP.UI.initButtonMenu({selector: $('.lp-menubar-scales', root), name: 'scaleMenu'});
            $('a[action="deleteScale"]', root).click(function () {
                LP.dlgQuestion.deleteOption(this, LP.scaleQuestion.scalesTab.checkFields);
            });
            $('a[action="toggleFixPos"]', root).click(LP.dlgQuestion.toggleFixPos);
            $('a[action="toggleInputType"]', root).click(LP.scaleQuestion.toggleInputType);

            $('a[action="toggleAddMultiple"]', root).click(LP.scaleQuestion.scalesTab.toggleAddMultiple);
            $('a[action="addMultiple"]', root).click(LP.scaleQuestion.scalesTab.addMultiple);

            $('.scaleStyleChooser').change(LP.scaleQuestion.changeStyle);

            LP.scaleQuestion.scalesTab.checkFields();
        },

        checkFields: function () {
            if (LP.scaleQuestion.dispatching) return; else LP.scaleQuestion.dispatching = true;

            var groups = $('#scaleFields');
            groups.children().each(function (index, group) {
                if ($('li', group).length === 0) {
                    LP.dlgQuestion.addOption($('#newGroup'), $('ul', group), LP.scaleQuestion.scalesTab.initEvents);
                }
            });

            $('.inputnum').each(function (index, element) {
                $(element).html((index + 1) + '.');
            });

            LP.scaleQuestion.dispatching = false;
        },

        toggleAddMultiple: function () {
            var $this = $(this);
            var $area = $this.siblings('textarea');
            var $button = $area.siblings('a[action="addMultiple"]');

            if ($area.is(':visible')) {
                $area.fadeOut('fast');
                $button.fadeOut('fast');
            } else {
                $area.fadeIn('fast');
                $button.fadeIn('fast');
            }
        },

        addMultiple: function () {
            var $this = $(this);
            var $area = $this.siblings('textarea');
            var options = $area.val();
            var $last = $this.siblings('ul').find('li').last();
            if ($last.length == 0) return;

            if (options != '') {
                var whichSide = 'left',
                    leftLength = $last.find('input[name="question[leftText][]"]').val().length,
                    rightLength = $last.find('input[name="question[rightText][]"]').val().length;
                if ($last.length > 0 && leftLength == 0 && rightLength > 0) {
                    whichSide = 'right';
                }

                var optionArray = options.split(/[\r\n]+/); // split by newlines (and filter empty rows)
                optionArray.forEach(function (option) {
                    if (option.trim() == '') return; // ignore empty lines

                    LP.dlgQuestion.addOptionHere($('#newGroup'), $last, function (element) {
                        var $element = $(element);
                        $element.find('input[name="question[' + whichSide + 'Text][]"]').val(option.trim());

                        $last = $element;
                    });
                });
                LP.scaleQuestion.scalesTab.initEvents($('.lp-answer-list'));
            }

            // and now we clean and close the input again
            $area.val('');
            LP.scaleQuestion.scalesTab.toggleAddMultiple.call(this);
        }
    },

    advTab: {
        initEvents: function () {
            var scaleSumMin = $('#scale_sum_min');
            var scaleSumMax = $('#scale_sum_max');

            UI.setupSpinbox(scaleSumMin, -2147483648, 2147483648, scaleSumMin.val(), 1, false, 0, true, false, false);
            UI.setupSpinbox(scaleSumMax, -2147483648, 2147483648, scaleSumMax.val(), 1, false, 0, true, false, false);

            $('.scaleAutoLabel').click(function () {
                var input = $(this);
                var div = input.closest('.autoLabelRow');
                if (input.is(':checked')) {
                    $('.selectAutoLabel', div).removeAttr('disabled');
                } else {
                    $('.selectAutoLabel', div).attr('disabled', '1');
                }
            });

            $('.scaleCustomAlign').change(function () {
                LP.scaleQuestion.advTab.onCustomAlign($(this));
            });

            $('.scaleCustomLabel').click(function () {
                var input = $(this);
                var div = input.closest('.customLabelRow');
                if (input.is(':checked')) {
                    $('.scaleCustomAlign', div).removeAttr('disabled');
                    $('.scale_label', div).removeAttr('disabled').css('background', '');
                    LP.scaleQuestion.advTab.onCustomAlign($('.scaleCustomAlign', div));
                } else {
                    $('.scaleCustomAlign', div).attr('disabled', '1');
                    $('.scale_label', div).attr('disabled', '1').css('background', '#F0F0F0');
                }
            });

            $('a[action="editLeftLabel"]').click(function () {
                LP.dlgQuestion.editInput($('input', this.parentNode), this);
            });
            $('a[action="editCenterLabel"]').click(function () {
                LP.dlgQuestion.editInput($('input', this.parentNode), this);
            });
            $('a[action="editRightLabel"]').click(function () {
                LP.dlgQuestion.editInput($('input', this.parentNode), this);
            });

        },
        onCustomAlign: function (select) {
            var td = select.parent();
            var align = $('option:selected', select);
            if (align.val() === 'ASIDE') {
                $('.center', td).attr('disabled', '1').css('background', '#F0F0F0');
            } else {
                $('.center', td).removeAttr('disabled').css('background', '');
            }
        },
        setupScale: function (fieldId) {
            var defValue = $('#defValue_' + fieldId);
            var minValue = $('#minValue_' + fieldId);
            var maxValue = $('#maxValue_' + fieldId);
            var stepValue = $('#stepValue_' + fieldId);
            var stepRange = $('#stepRange_' + fieldId);
            var widthValue = $('#widthValue_' + fieldId);

            UI.setupSpinbox(defValue, -2147483648, 2147483648, defValue.val(), 1, true, 0, true, false, true);
            UI.setupSpinbox(minValue, -2147483648, 2147483648, minValue.val(), 1, true, 0, false, false, true);
            UI.setupSpinbox(maxValue, -2147483648, 2147483648, maxValue.val(), 1, true, 0, false, false, true);
            UI.setupSpinbox(stepValue, 0, 2147483648, stepValue, 1, true, 0, false, false, true);
            UI.setupSpinbox(stepRange, 1, 20, stepRange.val(), 1, false, 0, false, false, false);
            UI.setupSpinbox(widthValue, 1, 500, widthValue.val(), 1, true, 0, false, false, true);

            $('#matrix_fieldtype_' + fieldId).change(function () {
                var val = $(this).val();
                var parent = $(this).closest('fieldset');
                if (val === 'FIELD') {
                    $('.matrix_adv_slider', parent).hide();
                } else {
                    $('.matrix_adv_slider', parent).show();
                }
            });

            var floatField = $('#floating_' + fieldId);
            if (floatField.is(':checked')) {
                $('.matrix-scale-steps', floatField.closest('tr')).hide();
            } else {
                $('.matrix-scale-steps', floatField.closest('tr')).show();
            }

            floatField.click(function () {
                if ($(this).is(':checked')) {
                    $('.matrix-scale-steps', $(this).closest('tr')).hide();
                } else {
                    $('.matrix-scale-steps', $(this).closest('tr')).show();
                }
            });
        }
    },

    toggleInputType: function () {
        var $this = $(this);
        if ($this.is('[disabled]')) return false;
        var $input = $('input', $this.parent());
        var hasinput = $input.attr('value') !== '1';
        $input.attr('value', hasinput ? 1 : 0);
        $this.toggleClass('icon-edit', !hasinput);
        $this.toggleClass('icon-ok', hasinput);
    },

    changeStyle: function () {
        var $this = $(this);
        var root = $('#scaleFields');
        if ($this.val() == 'NP') {
            $('a[action="toggleInputType"]', root).attr('disabled', '1');
        } else {
            $('a[action="toggleInputType"]', root).removeAttr('disabled');
        }
    }
};
